/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-nested-ternary */

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Breadcrumb, message, Input, Modal, Badge } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ReloadOutlined, MinusOutlined } from '@ant-design/icons';
import { changeRiderStatus, deleteRider, getAllRiders } from '../../redux/riderSlice';
import DrawerRider from './DrawerRider';
import { style } from '../../Styles';
import ActionButtonWithChangeStatus from '../Global/ActionButtonWithChangeStatus';
import ImageComponent from '../Global/ImageComponent/ImageComponent';
import CustomAvatar from '../Global/CustomAvatar/CustomAvatar';
import CustomTableComponentsPageable from '../Global/CustomTableComponentsPageable';
import { CheckRiderEnabled } from '../../Utils/CheckFeatures';

const Rider = ({ isActive }) => {
	const [search, setSearch] = useState('');
	const [sortBy, setSortBy] = useState('created');
	const [sortDirection, setSortDirection] = useState('DESC');
	const searchTimerRef = useRef(null);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);

	const columns = [
		{
			title: 'Profile Picture',
			key: 'profilePicture',
			render: (record) => {
				return record.profilePicture ? (
					<ImageComponent size={40} imageId={record?.profilePicture} />
				) : (
					<CustomAvatar name={`${record.name} ${record.surname}`} type='initials' />
				);
			},
			width: 130,
			show: true,
		},
		{
			title: 'Name',
			key: 'name',
			render: (record) => {
				return <span>{`${record.name} ${record.surname}`}</span>;
			},
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			show: true,
		},
		{
			title: 'Email',
			dataIndex: 'email',
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			show: true,
		},
		{
			title: 'Phone',
			key: 'phone',
			render: (record) => {
				return <span>{`+(${record.phoneCountryCode}) ${record.phone}`}</span>;
			},
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			show: true,
		},
		{
			title: 'Gender',
			key: 'gender',
			render: (record) => {
				return record?.gender ? <span>{record.gender}</span> : <MinusOutlined />;
			},
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			show: true,
		},
		{
			title: 'Application Status',
			key: 'applicationStatus',
			render: (record) => {
				const getStatusBadge = (status) => {
					switch (status) {
						case 'APPROVED':
							return (
								<Badge
									color='#52c41a'
									text={
										<span style={{ color: '#389e0d', fontWeight: 'bold' }}>
											APPROVED
										</span>
									}
								/>
							);
						case 'DENIED':
							return (
								<Badge
									color='#ff4d4f'
									text={
										<span style={{ color: '#cf1322', fontWeight: 'bold' }}>
											DENIED
										</span>
									}
								/>
							);
						case 'PENDING':
							return (
								<Badge
									color='#d9d9d9'
									text={
										<span style={{ color: '#d9d9d9', fontWeight: 'bold' }}>
											PENDING
										</span>
									}
								/>
							);
						default:
							return (
								<span style={{ color: '#8c8c8c', fontWeight: 'bold' }}>
									_
								</span>
							);
					}
				};
				const riderApplicationStatus = record.taxiModeWithRole?.find(r => r.role === "RIDER")?.applicationStatus || null;
				return getStatusBadge(riderApplicationStatus);
			},
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			width: 160,
			show: CheckRiderEnabled(),
		},
		{
			title: 'Status',
			key: 'active',
			render: (record) => {
				return (
					<span style={style.dataContainer}>
						{record.active ? (
							<div style={style.statusActif}>ACTIVE</div>
						) : (
							<div style={style.statusInactif}>INACTIVE</div>
						)}
					</span>
				);
			},
			sorter: true,
			sortDirections: ['ascend', 'descend'],
			width: 90,
			show: true,
		},
		{
			title: 'Actions',
			key: 'actions',
			render: (text, record) => (
				<ActionButtonWithChangeStatus
					record={record}
					onDelete={() => handleDlete(record.id, () => { })}
					onRowClick={() => handleSelectedRider(record)}
					onChangeStatus={() => handleChangeStatus(record)}
				/>
			),

			show: true,
		},
	];
	const [displayDrawer, setDisplayDrawer] = useState(false);
	const [selectedRider, setSelectedRider] = useState(null);
	const [isMakingApiCall, setMakingApiCall] = useState(true);
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [batchActionModal, setBatchActionModal] = useState({
		visible: false,
		action: null, // 'disable' or 'enable'
	});
	const showDrawer = () => {
		setDisplayDrawer(true);
	};
	const onCloseDrawer = () => {
		setDisplayDrawer(false);
		setSelectedRider(null);
	};

	const dispatch = useDispatch();

	const { Riders } = useSelector((state) => state.riders);
	const fetchAll = () => {
		setMakingApiCall(true);
		dispatch(
			getAllRiders({
				page: currentPage - 1,
				size: pageSize,
				search,
				sortBy,
				sortDirection,
			})
		)
			.unwrap()
			.catch(() => {
				message.error('Error fetching riders');
			})
			.finally(() => {
				setMakingApiCall(false);
			});
	};

	const sortFieldMap = {
		applicationStatus: 'taxiModeWithRole.applicationStatus',
	};

	const handleTableChange = (_, __, sorter, extra) => {
		if (extra?.action !== 'sort') return;
		if (sorter.order) {
			const field = sorter.columnKey || sorter.field;
			setSortBy(sortFieldMap[field] || field);
			setSortDirection(sorter.order === 'ascend' ? 'ASC' : 'DESC');
		} else {
			setSortBy('created');
			setSortDirection('DESC');
		}
		setCurrentPage(1);
	};

	useEffect(() => {
		fetchAll();
	}, [currentPage, pageSize, search, sortBy, sortDirection]);

	// Fetch data when tab becomes active
	useEffect(() => {
		if (isActive) {
			fetchAll();
		}
	}, [isActive]);

	const handleDlete = (id, calbback) => {
		setMakingApiCall(true);
		dispatch(
			deleteRider({
				riderId: id,
			}),
		)
			.unwrap()
			.then(() => {
				message.success('Rider deleted successfully');
				calbback();
			})
			.catch(() => { })
			.finally(() => {
				onCloseDrawer();
				setMakingApiCall(false);
			});
	};

	const handleChangeStatus = (record) => {
		setMakingApiCall(true);
		dispatch(
			changeRiderStatus({
				userId: record.id,
				active: !record.active,
			}),
		)
			.unwrap()
			.then(() => {
				message.success('Driver status updated successfully');
			})
			.catch((e) => {
				const errorMessage = e?.message || 'Error updating user status';
				if (errorMessage === 'DRIVER_SHOULD_UPLOAD_DOCUMENTS_TO_BE_ACTIVATED') {
					message.error(
						'This user is also a driver, so the required driver documents must be uploaded before activation.',
					);
				} else {
					message.error(errorMessage);
				}
			})
			.finally(() => {
				setMakingApiCall(false);
			});
	};

	const handleSelectedRider = (selectedRider) => {
		setSelectedRider(selectedRider);
		showDrawer();
	};

	const handleBatchAction = (action) => {
		if (selectedRowKeys.length === 0) {
			message.warning(`Please select riders to ${action}`);
			return;
		}

		// Filter riders based on the action
		const selectedRiders = ridersArray.filter(rider => selectedRowKeys.includes(rider.id));
		let validRiders = [];

		if (action === 'disable') {
			validRiders = selectedRiders.filter(rider => rider.active);
		} else if (action === 'enable') {
			validRiders = selectedRiders.filter(rider => !rider.active);
		}

		if (validRiders.length === 0) {
			message.warning(`No riders available to ${action}`);
			return;
		}

		setBatchActionModal({
			visible: true,
			action,
		});
	};

	const confirmBatchAction = async () => {
		try {
			setMakingApiCall(true);

			const isDisable = batchActionModal.action === 'disable';
			const selectedRiders = ridersArray.filter(rider => selectedRowKeys.includes(rider.id));

			// Filter based on action
			const validRiders = isDisable
				? selectedRiders.filter(rider => rider.active)
				: selectedRiders.filter(rider => !rider.active);

			// Process each valid rider
			const actionPromises = validRiders.map(rider =>
				dispatch(changeRiderStatus({
					userId: rider.id,
					active: !isDisable,
				})).unwrap()
			);

			await Promise.all(actionPromises);

			message.success(`${validRiders.length} rider(s) ${batchActionModal.action}d successfully`);
			setSelectedRowKeys([]);
			setBatchActionModal({ visible: false, action: null });

		} catch (error) {
			message.error(`Error ${batchActionModal.action}ing riders`);
		} finally {
			setMakingApiCall(false);
		}
	};

	let ridersArray = Object.values(Riders.ridersList);
	ridersArray = ridersArray.map((item) => {
		return { ...item, key: item.id };
	});

	return (
		<>
			<Card
				style={{
					margin: 16,
					maxHeight: '90%', // Set maximum width
					height: 'auto', // Allow width to be dynamic
				}}>
				<div style={style.inlineContent}>
					<div
						style={{
							display: 'flex',
							alignContent: 'center',
							alignItems: 'center',
							float: 'left',
							marginBottom: 8,
						}}>
						<Breadcrumb
							style={{ margin: '0 3em 0 0', fontSize: '1.1em' }}
							items={[
								{
									title: 'Riders',
								},
							]}
						/>
						<Button
							type='default'
							size='small'
							// style={{ margin: '0 8px 8px 0' }}
							onClick={() => fetchAll()}>
							<ReloadOutlined />
						</Button>
						{selectedRowKeys.length > 0 && (() => {
							const selectedRiders = ridersArray.filter(rider => selectedRowKeys.includes(rider.id));
							const activeRiders = selectedRiders.filter(rider => rider.active);
							const inactiveRiders = selectedRiders.filter(rider => !rider.active);

							return (
								<>
									{activeRiders.length > 0 && (
										<Button
											type="primary"
											danger
											size="small"
											style={{ marginLeft: 8 }}
											onClick={() => handleBatchAction('disable')}
											disabled={isMakingApiCall}
										>
											Disable Selected ({activeRiders.length})
										</Button>
									)}
									{inactiveRiders.length > 0 && (
										<Button
											type="primary"
											size="small"
											style={{ marginLeft: 8, backgroundColor: '#52c41a', borderColor: '#52c41a' }}
											onClick={() => handleBatchAction('enable')}
											disabled={isMakingApiCall}
										>
											Enable Selected ({inactiveRiders.length})
										</Button>
									)}
								</>
							);
						})()}
					</div>
					<div
						style={{
							...style.inlineContent,
							float: 'right',
							marginBottom: 8,
						}}>
						<Input.Search
							placeholder="Search riders"
							allowClear
							onSearch={(value) => {
								clearTimeout(searchTimerRef.current);
								setCurrentPage(1);
								setSearch(value);
							}}
							onChange={(e) => {
								clearTimeout(searchTimerRef.current);
								const val = e.target.value;
								searchTimerRef.current = setTimeout(() => {
									setCurrentPage(1);
									setSearch(val);
								}, 400);
							}}
							style={{ margin: '0 8px 8px 0' }}
						/>

						<Button
							type='default'
							style={{ float: 'right', marginBottom: 8 }}
							onClick={showDrawer}>
							Add Rider
						</Button>
					</div>
				</div>
				<CustomTableComponentsPageable
					isMakingApiCall={isMakingApiCall}
					columns={columns.filter((item) => item.show)}
					dataArray={ridersArray}
					handleSelectedRow={() => { }}
					handleDoubleClickRow={(record) => handleSelectedRider(record)}
					onTableChange={handleTableChange}
					rowSelection={{
						selectedRowKeys,
						onChange: setSelectedRowKeys,
						type: 'checkbox',
					}}
					pagination={{
						current: currentPage,
						pageSize,
						total: Riders.total || 0,
						onChange: (page, size) => {
							setCurrentPage(page);
							setPageSize(size);
						},
					}}
				/>
			</Card>
			{displayDrawer && (
				<DrawerRider
					onClose={onCloseDrawer}
					riderId={selectedRider?.id}
					handleDlete={handleDlete}
				/>
			)}

			{/* Batch Action Confirmation Modal */}
			<Modal
				title={`${batchActionModal.action === 'disable' ? 'Disable' : 'Enable'} Selected Riders`}
				open={batchActionModal.visible}
				onOk={confirmBatchAction}
				onCancel={() => setBatchActionModal({ visible: false, action: null })}
				confirmLoading={isMakingApiCall}
				okText={batchActionModal.action === 'disable' ? 'Disable' : 'Enable'}
				okButtonProps={{
					danger: batchActionModal.action === 'disable',
					style: batchActionModal.action === 'enable' ? { backgroundColor: '#52c41a', borderColor: '#52c41a' } : {}
				}}
			>
				{(() => {
					const selectedRiders = ridersArray.filter(rider => selectedRowKeys.includes(rider.id));
					const validRiders = batchActionModal.action === 'disable'
						? selectedRiders.filter(rider => rider.active)
						: selectedRiders.filter(rider => !rider.active);

					return (
						<>
							<p>Are you sure you want to {batchActionModal.action} {validRiders.length} selected rider(s)?</p>
							<p>
								{batchActionModal.action === 'disable'
									? 'This action will make them inactive in the system.'
									: 'This action will make them active in the system.'}
							</p>
						</>
					);
				})()}
			</Modal>
		</>
	);
};

Rider.propTypes = {
	isActive: PropTypes.bool,
};

Rider.defaultProps = {
	isActive: false,
};

export default Rider;
